import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import contact from '@/pages/help_center/watch_videos/watch_videos.module.scss'

import { NavLink } from '@/components/atoms/NavLink/NavLink'
import { Footer } from '@/components/organisms/Footer/Footer'
import { watchvideo } from '@/data/dummy/watchvideo'
import { WatchVideo } from '@/components/organisms/WatchVideo/WatchVideo'
export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };
  const watchvideolGrups = chunk(watchvideo, 3)

  return (
    <>
      <Menu />
      {watchvideolGrups.map((group, index) => (
        <div key={index} className={contact.body_section}>
          {group.map((watchvideo, index) => (
            <WatchVideo key={index} {...watchvideo} />
          ))}
        </div>
      ))}
      <div className={contact.container2}>    <NavLink href='/help_center' type='submit' name='Volver' className={contact.button3} /></div>
      <Footer />
    </>
  )
}
